import firebase from "firebase";
import { firebaseCfg } from "./properties";
import { callService } from "./tools";

firebase.initializeApp( firebaseCfg );

export const storage = firebase.storage();
export const database = firebase.database();
export const authentication = firebase.auth();
export const fbDbRefs = [];

export const cerrarSesion = () => {
	new callService({
		service: "login.cerrarsesion",
		"secure": true
	}).execute().then(sResultado => {
		console.log("sResultado", sResultado);
	}).catch(error => {
		console.log("error", error);
	});
};

export const logOut = () => {
	if (authentication && authentication.currentUser && authentication.currentUser.uid) {
		database.ref("portales/" + authentication.currentUser.uid + "/cerrar").set(false);   
		cerrarSesion();
		authentication.signOut();
	}
	clearReference();
};

export const clearReference = () => {
	for (var ref of fbDbRefs) {
		ref.off();
	}
	fbDbRefs.splice(0, fbDbRefs.length);
};

export const loginActive = () => {
	console.log('se llama loginACTIVE', authentication.currentUser.uid);
	database.ref("sesionesactivas/" + authentication.currentUser.uid).once("value").then((snapshot) =>{
        const retrieveddate = snapshot.val();
        console.log(retrieveddate,'aqui es');
		if(retrieveddate === null) {
			console.log('hola');
			logOut();
			if(localStorage.getItem("esCliente")){
				localStorage.removeItem("esCliente");
				localStorage.removeItem("planesCliente");
				localStorage.removeItem("esMoral");
			}else {
				console.log('no esta logeado');
			}
		}else {
			console.log('sigue activo');
		}
    });
};

export const cierraSesionAppLogin = () => {
	console.log('cierra sesion en la app');
	logOut();
	localStorage.removeItem("esCliente");
	localStorage.removeItem("planesCliente");
	localStorage.removeItem("esMoral");
	database.ref("sesionMovil/" + authentication.currentUser.uid).remove();
	database.ref("sesionMovil_fix/" + authentication.currentUser.uid).remove();
}



// WEBPACK FOOTER //
// ./src/app-database.js